// extracted by mini-css-extract-plugin
export default {"content":"confirmModal_content__PrV-a","image":"confirmModal_image__ojzfg","container":"confirmModal_container__NutP2","text":"confirmModal_text__oUl79"};